import { useForm } from 'react-hook-form'
import Form from '../../../components/Form'
import FormItem from '../../../components/Form/FormItem'
import Button from '../../../components/General/Button'
import Datepicker from '../../../components/Inputs/Datepicker'
import InputNumber from '../../../components/Inputs/InputNumber'
import InputText from '../../../components/Inputs/InputText'
import { TextArea } from '../../../components/Inputs/TextArea'
import useSnackBars from '../../../hooks/SnackbarConsumerHook'
import { getYearMonthAndDay } from '../../../utils/utils'

const PurchaseNoteForm: React.FC<PurchaseNoteFormProps> = ({
  onClose,
  setPurchaseNote,
  editingLoadNote = null,
  fromAdministration = false
}) => {
  const form = useForm({ defaultValues: { ...editingLoadNote } })
  const { addAlert } = useSnackBars()

  const handleSubmit = (values) => {
    const [year, month, day] = getYearMonthAndDay(values.emisionDate)
    const emisionD = new Date(year, month, day)

    const [year2, month2, day2] = getYearMonthAndDay(values.expirationDate)
    const expirationD = new Date(year2, month2, day2)

    const [year3, month3, day3] = getYearMonthAndDay(values.bookDate)
    const bookD = new Date(year3, month3, day3)

    if (emisionD.getTime() > expirationD.getTime()) {
      addAlert({
        message: 'Fecha de creación debe ser menor a la fecha de expiración',
        status: 'error',
      })
      return
    }

    if (bookD.getTime() > expirationD.getTime()) {
      addAlert({
        message: 'Fecha de libro debe ser menor a la fecha de expiración',
        status: 'error',
      })
      return
    }

    if (bookD.getTime() < emisionD.getTime()) {
      addAlert({
        message: 'Fecha de libro debe ser mayor a la fecha de creación',
        status: 'error',
      })
      return
    }

    setPurchaseNote({ ...values })
    onClose()
  }

  return (
    <Form
      form={form}
      onSubmit={(values) => handleSubmit(values)}
      classes={`gap-x-6 gap-y-2`}
    >
      <h1 className="font-bold text-primary-900 dark:text-gray-400 mb-8 col-span-12">
        Datos de Factura
      </h1>
      <FormItem
        name="serial"
        classes="xl:col-span-6 col-span-12"
        rules={{ required: 'El campo código es requerido' }}
      >
        <InputText label="Código en documento" maxLength={255} />
      </FormItem>

      <FormItem
        name="control"
        classes="xl:col-span-6 col-span-12"
        rules={{ required: 'El número de control es requerido' }}
      >
        <InputText label="Número de control" maxLength={255} />
      </FormItem>
      <FormItem
        name="emisionDate"
        classes="xl:col-span-6 col-span-12"
        rules={{
          required:
            'Debe especificar la fecha de emisión de la nota de entrega',
        }}
      >
        <Datepicker label="Fecha de Creación" />
      </FormItem>
      <FormItem
        name="expirationDate"
        classes="xl:col-span-6 col-span-12"
        rules={{
          required:
            'Debe especificar la fecha de expiración para la nota de entrega',
        }}
      >
        <Datepicker label="Fecha de Expiración" />
      </FormItem>

      <FormItem
        name="bookDate"
        classes="xl:col-span-6 col-span-12"
        rules={{
          required:
            'Debe especificar la fecha para del proceso para el registro',
        }}
      >
        <Datepicker label="Fecha de Libro" />
      </FormItem>

      { fromAdministration && (
        <FormItem name='total' classes="xl:col-span-6 col-span-12">
          <InputNumber label='Total' step={0.01} />
        </FormItem>
      )}

      <FormItem name="notes" classes="col-span-12">
        <TextArea
          label="Notas"
          placeholder="Notas adicionales de la nota de entrega..."
          maxLength={255}
        />
      </FormItem>
      <div className="col-span-12 flex space-x-2 px-1 mt-3">
        <Button
          type="outline"
          classes="w-1/2 mr-4"
          onClick={() => onClose()}
          htmlType="button"
        >
          Cancelar
        </Button>

        <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
          Guardar
        </Button>
      </div>
    </Form>
  )
}

interface PurchaseNoteFormProps {
  onClose: Function
  setPurchaseNote: Function
  editingLoadNote?: {
    bookDate: string
    emisionDate: string
    expirationDate: string
    serial: string
    notes: string
  } | null
  fromAdministration?: boolean
}

export default PurchaseNoteForm
